import React, { createContext, useMemo, useState } from 'react'

export type Progress = {
  showToast: boolean
}

export const progressInitialState = (): Progress => {
  return {
    showToast: false,
  }
}

type ProgressContextType = {
  progress: Progress
  setProgress: React.Dispatch<React.SetStateAction<Progress>>
}

export const ProgressContext = createContext<ProgressContextType>({
  progress: progressInitialState(),
  setProgress: () => null,
})
export default ProgressContext

export const ProgressProvider = ({
  children,
}: {
  children: JSX.Element
}): JSX.Element => {
  const [progress, setProgress] = useState(progressInitialState())
  const value = useMemo(
    () => ({
      progress,
      setProgress,
    }),
    [progress],
  )

  return (
    <ProgressContext.Provider value={value}>
      {' '}
      {children}{' '}
    </ProgressContext.Provider>
  )
}
